/**
 * @license
 * Copyright (c) 2019 %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

export type FormatterFunc<V> = (value: V) => string;
export type ParserFunc<V> = (value: string) => V;
export type FormatObj<V> = { format: FormatterFunc<V> };
export type ParseObj<V> = { parse: ParserFunc<V> };

// Errors thrown during format or parse include an 'options' object in this shape.
export type FormatParseErrorOptions = {
  cause?: {
    code: string;
    parameterMap?: Record<string, string | number>;
  };
};
// Type of error thrown during format or parse.
export class FormatParseError extends Error {
  readonly cause: FormatParseErrorOptions['cause'];
  constructor(message?: string, options?: FormatParseErrorOptions) {
    super(message); // 'Error' breaks prototype chain here
    Object.setPrototypeOf(this, FormatParseError.prototype);
    this.cause = options?.cause;
  }
}
